/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pw_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes. Generation happens entirely in your browser using JavaScript that runs on your device — the password is never sent to a server, logged, or stored anywhere. Reload the page and it's gone, the same as if it never existed outside your screen.`)
};

const es_pw_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sí. La generación ocurre enteramente en tu navegador usando JavaScript que se ejecuta en tu dispositivo — la contraseña nunca se envía a un servidor, se registra, o se almacena en ningún lado. Recarga la página y se ha ido, igual que si nunca hubiera existido fuera de tu pantalla.`)
};

const de_pw_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja. Die Generierung erfolgt vollständig in Ihrem Browser mit JavaScript, das auf Ihrem Gerät ausgeführt wird — das Passwort wird niemals an einen Server gesendet, protokolliert oder irgendwo gespeichert. Aktualisieren Sie die Seite und es ist weg, das gleiche, als hätte es nie außerhalb Ihres Bildschirms existiert.`)
};

const nl_pw_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja. Generatie gebeurt volledig in je browser met JavaScript dat op je apparaat draait — het wachtwoord wordt nooit naar een server verzonden, gelogd, of ergens opgeslagen. Ververs de pagina en het is weg, hetzelfde als of het nooit buiten je scherm bestond.`)
};

const fr_pw_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oui. La génération se produit entièrement dans votre navigateur en utilisant du JavaScript qui s'exécute sur votre appareil — le mot de passe n'est jamais envoyé à un serveur, enregistré ou stocké nulle part. Rechargez la page et il disparaît, comme s'il n'avait jamais existé en dehors de votre écran.`)
};

const it_pw_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sì. La generazione avviene interamente nel tuo browser utilizzando JavaScript che viene eseguito sul tuo dispositivo — la password non viene mai inviata a un server, registrata o conservata da nessuna parte. Ricarica la pagina e sarà sparita, come se non fosse mai esistita al di fuori dello schermo.`)
};

const pt_br2_pw_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim. A geração acontece inteiramente em seu navegador usando JavaScript que é executado em seu dispositivo — a senha nunca é enviada para um servidor, registrada ou armazenada em lugar nenhum. Atualize a página e se foi, assim como se nunca tivesse existido fora de sua tela.`)
};

const pt_pw_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim. A geração ocorre inteiramente no seu navegador utilizando JavaScript que funciona no seu dispositivo — a senha nunca é enviada para um servidor, registada ou armazenada em lado nenhum. Recarregue a página e desaparece, o mesmo que se nunca tivesse existido fora do seu ecrã.`)
};

const ja_pw_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`はい。生成はブラウザで実行するJavaScriptを使用して完全にローカルで行われます。パスワードはサーバーに送信されたり、ログに記録されたり、どこにも保存されたりしません。ページをリロードすると、画面外に存在していなかったのと同じように消えます。`)
};

const zh_pw_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`是的。生成过程完全在你的浏览器中通过运行于你设备上的 JavaScript 完成——密码永远不会发送到服务器，也不会被记录或存储在任何地方。重新加载页面它就消失了，就像它从未在你的屏幕之外存在过一样。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pw_faq2_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pw_faq2_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pw_faq2_a", locale)
	if (locale === "en") return en_pw_faq2_a(inputs)
	if (locale === "es") return es_pw_faq2_a(inputs)
	if (locale === "de") return de_pw_faq2_a(inputs)
	if (locale === "nl") return nl_pw_faq2_a(inputs)
	if (locale === "fr") return fr_pw_faq2_a(inputs)
	if (locale === "it") return it_pw_faq2_a(inputs)
	if (locale === "pt-BR") return pt_br2_pw_faq2_a(inputs)
	if (locale === "pt") return pt_pw_faq2_a(inputs)
	if (locale === "ja") return ja_pw_faq2_a(inputs)
	return zh_pw_faq2_a(inputs)
};